import { render, staticRenderFns } from "./jm.vue?vue&type=template&id=3b178fa2&scoped=true"
import script from "./jm.vue?vue&type=script&lang=js"
export * from "./jm.vue?vue&type=script&lang=js"
import style0 from "./jm.vue?vue&type=style&index=0&id=3b178fa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b178fa2",
  null
  
)

export default component.exports